import getApi from "@/lib/axios/authAxiosInstance";
import {VuexParams, Params} from "@/interfaces/actionParamsInterface";

// Get profile
export function getProfile({ commit }: VuexParams, {callback}: Params) {
    const axios = getApi();
    axios
        .get('/user/api/me')
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            callback({error: error.response?.data})
        });
}

// Update user address
export function updateUserAddress({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();
    axios
        .put('/user/api/me/address', {
            address: {
                number: data.number || '',
                street: data.street || data.name || '',
                postalCode: data.postalCode,
                city: data.city,
                state: data.state,
                country: data.country,
            }
        })
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            callback({error: error.response?.data})
        });
}

export function updateUserProfile({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();
    axios
        .put('/user/api/me/profile', {
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber
        })
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            callback({error: error.response?.data})
        });
}

export function getSupportingDocuments({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();
    axios
        .get('/user/api/supporting-documents/latest')
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            callback({error: error.response?.data})
        });
}
export function sendSupportingDocument({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();
    const form = new FormData();
    form.append('type', data.type);
    data.files.forEach((file: any) => {
        form.append('files', file);
    })

    axios
        .post('/user/api/supporting-documents', form)
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            callback({error: error.response?.data})
        });
}
export function sendDownloadDataRequest({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();

    axios.post('/user/api/me/gdpr-data-download', {phoneNumber: data.phoneNumber})
        .then((response) => {
            callback(response)
        }).catch((error) => {
            callback({error: error.response?.data})
        });
}

export function unsubscribeNewsletter({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();

    axios.post('/user/api/me/braze-unsubscribe', {})
        .then((response) => {
            callback(response)
        }).catch((error) => {
            callback({error: error.response?.data})
        });
}
export function getBrazeStatus({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();

    axios.get('/user/api/me/braze-status', {})
        .then((response) => {
            callback(response)
        }).catch((error) => {
            callback({error: error.response?.data})
        });
}
export function subscribeNewsletter({ commit }: VuexParams, {data, callback}: Params) {
    const axios = getApi();

    axios.post('/user/api/me/braze-subscribe', {})
        .then((response) => {
            callback(response)
        }).catch((error) => {
            callback({error: error.response?.data})
        });
}
